<template>
  <div class="page-container">
    <el-card class="page-content" shadow="never">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <div class="breadcrumb">
            <div class="left"></div>
            <div class="right"><h2>iOS限制设置</h2></div>
          </div>
        </el-breadcrumb-item>
      </el-breadcrumb>

      <div class="page-actions ios-limit-actions">
        <div class="select">
          <div class="item">
            <div class="ipt">
              <el-input v-model.trim="filters.version" clearable size="mini" placeholder="App版本" @keyup.enter.native="handleSearch" />
            </div>
          </div>
          <div class="item">
            <div class="ipt">
              <el-select v-model="filters.enabled" clearable size="mini" placeholder="状态">
                <el-option label="启用" :value="true" />
                <el-option label="禁用" :value="false" />
              </el-select>
            </div>
          </div>
        </div>
        <div>
          <el-button size="mini" type="primary" @click="handleSearch">查询</el-button>
          <el-button size="mini" @click="handleReset">重置</el-button>
          <el-button size="mini" type="primary" icon="el-icon-plus" @click="openCreate">新增配置</el-button>
        </div>
      </div>

      <el-table :data="rows" border size="mini" style="width: 100%">
        <el-table-column label="序号" width="70" align="center">
          <template slot-scope="scope">{{ (pagination.page - 1) * pagination.size + scope.$index + 1 }}</template>
        </el-table-column>
        <el-table-column prop="platform" label="平台" width="100" />
        <el-table-column prop="version" label="App版本" width="140" show-overflow-tooltip />
        <el-table-column prop="checkMockUserIdList" label="需校验模拟用户白名单" min-width="190" show-overflow-tooltip />
        <el-table-column prop="bypassMockUserIdList" label="免校验模拟用户白名单" min-width="190" show-overflow-tooltip />
        <el-table-column prop="denyMessage" label="禁止提示语" min-width="220" show-overflow-tooltip />
        <el-table-column prop="kycMessage" label="KYC提示语" min-width="220" show-overflow-tooltip />
        <el-table-column prop="inviteUrl" label="邀请链接" min-width="220" show-overflow-tooltip />
        <el-table-column label="状态" width="100" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.enabled ? 'success' : 'info'" size="mini">{{ scope.row.enabled ? '启用' : '禁用' }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" min-width="160" show-overflow-tooltip />
        <el-table-column prop="updatedTime" label="更新时间" width="170" show-overflow-tooltip />
        <el-table-column label="操作" width="230" fixed="right" align="center">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="openEdit(scope.row)">编辑</el-button>
            <el-button type="text" size="mini" @click="openCopy(scope.row)">复制</el-button>
            <el-button type="text" size="mini" @click="handleSwitch(scope.row)">{{ scope.row.enabled ? '禁用' : '启用' }}</el-button>
            <el-button type="text" size="mini" class="danger-text" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        class="pager"
        background
        layout="total, prev, pager, next, sizes"
        :total="total"
        :page-size="pagination.size"
        :current-page.sync="pagination.page"
        :page-sizes="[10, 20, 50]"
        @size-change="handleSizeChange"
        @current-change="loadList"
      />
    </el-card>

    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="980px"
      :close-on-click-modal="false"
      @closed="resetForm"
    >
      <el-form ref="form" :model="form" :rules="rules" label-width="150px" size="mini">
        <el-form-item label="App版本" prop="version">
          <el-input v-model.trim="form.version" placeholder="例如：2.0.1" :disabled="dialogMode === 'edit'" />
        </el-form-item>
        <el-form-item label="需校验模拟用户白名单" prop="checkMockUserIdList">
          <el-input v-model.trim="form.checkMockUserIdList" type="textarea" :rows="2" placeholder="验证码固定123456，但仍走国家/地区/功能/KYC校验，多个用英文逗号隔开，最多5个" />
        </el-form-item>
        <el-form-item label="免校验模拟用户白名单" prop="bypassMockUserIdList">
          <el-input v-model.trim="form.bypassMockUserIdList" type="textarea" :rows="2" placeholder="验证码固定123456，gateway直接放行，多个用英文逗号隔开，最多5个" />
        </el-form-item>
        <el-form-item label="禁止访问提示语" prop="denyMessage">
          <el-input v-model.trim="form.denyMessage" type="textarea" :rows="2" maxlength="1000" show-word-limit />
        </el-form-item>
        <el-form-item label="KYC实名提示语" prop="kycMessage">
          <el-input v-model.trim="form.kycMessage" type="textarea" :rows="3" maxlength="1500" show-word-limit />
        </el-form-item>
        <el-form-item label="邀请链接">
          <el-input v-model.trim="form.inviteUrl" clearable maxlength="500" placeholder="命中iOS版本配置时返回的邀请码链接前缀" />
        </el-form-item>
        <el-form-item label="状态" prop="enabled">
          <el-switch v-model="form.enabled" active-text="启用" inactive-text="禁用" />
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model.trim="form.remark" type="textarea" :rows="2" maxlength="500" show-word-limit />
        </el-form-item>

        <div class="limit-section">
          <div class="section-title">
            <span>限制项目</span>
            <el-button size="mini" type="primary" icon="el-icon-plus" @click="addItem">添加限制项目</el-button>
          </div>
          <div v-for="(item, itemIndex) in form.items" :key="item.uid" class="limit-item">
            <div class="item-head">
              <el-select v-model="item.itemCode" filterable placeholder="请选择限制项目" size="mini" style="width: 240px" @change="handleItemChange(item)">
                <el-option v-for="option in availableItemOptions(item)" :key="option.itemCode" :label="option.itemName" :value="option.itemCode" />
              </el-select>
              <span class="api-text">{{ item.apiList }}</span>
              <el-button type="text" size="mini" class="danger-text" @click="removeItem(itemIndex)">删除项目</el-button>
            </div>
            <el-table :data="item.rules" border size="mini" style="width: 100%">
              <el-table-column label="国家" width="180">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.countryCode" size="mini" placeholder="国家" @change="handleCountryChange(scope.row)">
                    <el-option v-for="option in countryOptions" :key="option.value" :label="option.label" :value="option.value" />
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="地区" min-width="260">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.regionList" multiple filterable clearable size="mini" placeholder="不选默认全部地区" style="width: 100%" :disabled="scope.row.countryCode === 'OTHER'">
                    <el-option v-for="option in regionOptions(scope.row.countryCode)" :key="option.value" :label="option.label" :value="option.value" />
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="访问策略" width="180">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.accessPolicy" size="mini" placeholder="访问策略">
                    <el-option label="允许访问" value="ALLOW" />
                    <el-option label="禁止访问" value="DENY" />
                    <el-option label="KYC实名访问" value="KYC" />
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="90" align="center">
                <template slot-scope="scope">
                  <el-button type="text" size="mini" class="danger-text" @click="removeRule(item, scope.$index)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="rule-actions">
              <el-button size="mini" icon="el-icon-plus" @click="addRule(item)">添加规则</el-button>
            </div>
          </div>
        </div>
      </el-form>
      <span slot="footer">
        <el-button size="mini" @click="dialogVisible = false">取消</el-button>
        <el-button size="mini" type="primary" :loading="saving" @click="handleSave">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import api from './api'

const newRule = (countryCode = '', regionList = [], accessPolicy = 'DENY') => ({ uid: `${Date.now()}-${Math.random()}`, countryCode, regionList, accessPolicy })
const newItem = () => ({ uid: `${Date.now()}-${Math.random()}`, itemCode: '', itemName: '', apiList: '', rules: [newRule('OTHER', ['ALL'], 'DENY')] })
const emptyForm = () => ({
  id: null,
  version: '',
  checkMockUserIdList: '',
  bypassMockUserIdList: '',
  denyMessage: '',
  kycMessage: '',
  inviteUrl: '',
  enabled: false,
  remark: '',
  items: [],
})

export default {
  name: 'IosLimitSetting',
  data() {
    return {
      rows: [],
      total: 0,
      filters: { version: '', enabled: '' },
      pagination: { page: 1, size: 20 },
      dialogVisible: false,
      dialogMode: 'create',
      saving: false,
      form: emptyForm(),
      itemOptions: [],
      areaOptions: [],
      countryOptions: [],
      allRegionOptions: [{ label: '全部地区', value: 'ALL' }],
      rules: {
        version: [{ required: true, message: '请输入App版本', trigger: 'blur' }],
        denyMessage: [{ required: true, message: '请输入禁止访问提示语', trigger: 'blur' }],
        kycMessage: [{ required: true, message: '请输入KYC实名提示语', trigger: 'blur' }],
        checkMockUserIdList: [{ validator: (rule, value, callback) => this.validateMockUsers(value, callback), trigger: 'blur' }],
        bypassMockUserIdList: [{ validator: (rule, value, callback) => this.validateMockUsers(value, callback), trigger: 'blur' }],
      },
    }
  },
  mounted() {
    this.loadItemOptions()
    this.loadAreaOptions()
    this.loadList()
  },
  computed: {
    dialogTitle() {
      if (this.dialogMode === 'edit') return '编辑配置'
      if (this.dialogMode === 'copy') return '复制配置'
      return '新增配置'
    },
  },
  methods: {
    loadItemOptions() {
      api.itemOptions().then((res) => {
        this.itemOptions = Array.isArray(res && res.data) ? res.data : []
      })
    },
    loadAreaOptions() {
      api.areaOptions().then((res) => {
        const options = Array.isArray(res && res.data) ? res.data : []
        this.areaOptions = options
        this.countryOptions = options.map((item) => ({
          label: item.countryName,
          value: item.countryCode,
        }))
      })
    },
    loadList() {
      api.page({ page: this.pagination.page, size: this.pagination.size, version: this.filters.version || undefined, enabled: this.filters.enabled === '' ? undefined : this.filters.enabled }).then((res) => {
        const data = (res && res.data) || {}
        this.rows = Array.isArray(data.list) ? data.list : []
        this.total = data.totalCount || 0
      })
    },
    handleSearch() { this.pagination.page = 1; this.loadList() },
    handleReset() { this.filters = { version: '', enabled: '' }; this.handleSearch() },
    handleSizeChange(size) { this.pagination.size = size; this.pagination.page = 1; this.loadList() },
    openCreate() { this.dialogMode = 'create'; this.form = emptyForm(); this.dialogVisible = true },
    openEdit(row) {
      this.dialogMode = 'edit'
      api.detail(row.id).then((res) => {
        const data = (res && res.data) || {}
        this.form = this.normalizeDetail(data)
        this.dialogVisible = true
      })
    },
    openCopy(row) {
      this.dialogMode = 'copy'
      api.detail(row.id).then((res) => {
        const data = (res && res.data) || {}
        this.form = {
          ...this.normalizeDetail(data),
          id: null,
          version: '',
        }
        this.dialogVisible = true
      })
    },
    normalizeDetail(data) {
      return {
        ...emptyForm(),
        id: data.id,
        version: data.version,
        checkMockUserIdList: data.checkMockUserIdList || '',
        bypassMockUserIdList: data.bypassMockUserIdList || '',
        denyMessage: data.denyMessage || '',
        kycMessage: data.kycMessage || '',
        inviteUrl: data.inviteUrl || '',
        enabled: Boolean(data.enabled),
        remark: data.remark || '',
        items: Array.isArray(data.items) ? data.items.map((item) => ({
          uid: `${Date.now()}-${Math.random()}`,
          itemCode: item.itemCode,
          itemName: item.itemName,
          apiList: item.apiList,
          rules: Array.isArray(item.rules) ? item.rules.map((rule) => ({
            uid: `${Date.now()}-${Math.random()}`,
            countryCode: rule.countryCode,
            regionList: this.splitCsv(rule.regionList),
            accessPolicy: rule.accessPolicy,
          })) : [],
        })) : [],
      }
    },
    resetForm() { this.form = emptyForm(); this.saving = false; if (this.$refs.form) this.$refs.form.clearValidate() },
    addItem() { this.form.items.push(newItem()) },
    removeItem(index) { this.form.items.splice(index, 1) },
    addRule(item) { item.rules.push(newRule()) },
    removeRule(item, index) { item.rules.splice(index, 1) },
    handleItemChange(item) {
      const option = this.itemOptions.find((entry) => entry.itemCode === item.itemCode)
      item.itemName = option ? option.itemName : ''
      item.apiList = option ? option.apiList : ''
    },
    handleCountryChange(rule) {
      rule.regionList = rule.countryCode === 'OTHER' ? ['ALL'] : []
    },
    regionOptions(countryCode) {
      const option = this.areaOptions.find((item) => item.countryCode === countryCode)
      if (!option || !Array.isArray(option.regions) || !option.regions.length) {
        return this.allRegionOptions
      }
      return option.regions.map((item) => ({
        label: item.regionName,
        value: item.regionCode,
      }))
    },
    availableItemOptions(currentItem) {
      const selected = this.form.items.filter((item) => item !== currentItem).map((item) => item.itemCode).filter(Boolean)
      return this.itemOptions.filter((item) => !selected.includes(item.itemCode))
    },
    handleSave() {
      this.$refs.form.validate((valid) => {
        if (!valid || !this.validateItems()) return
        this.saving = true
        const request = this.dialogMode === 'edit' ? api.update : api.save
        request(this.buildPayload()).then((res) => {
          if (res && res.code === 0) {
            this.$message.success('保存成功')
            this.dialogVisible = false
            this.loadList()
          }
        }).finally(() => { this.saving = false })
      })
    },
    validateItems() {
      if (!this.form.items.length) { this.$message.error('请至少添加一个限制项目'); return false }
      const checkIds = this.splitCsv(this.form.checkMockUserIdList)
      const bypassIds = this.splitCsv(this.form.bypassMockUserIdList)
      if (bypassIds.some((id) => checkIds.includes(id))) { this.$message.error('两组模拟盘用户白名单不能重复'); return false }
      for (const item of this.form.items) {
        if (!item.itemCode || !item.apiList) { this.$message.error('请选择限制项目'); return false }
        if (!item.rules.length) { this.$message.error(`${item.itemName || '限制项目'}请至少配置一条规则`); return false }
        if (!item.rules.some((rule) => rule.countryCode === 'OTHER')) { this.$message.error(`${item.itemName}必须配置其他国家规则`); return false }
        for (const rule of item.rules) {
          if (!rule.countryCode || !rule.accessPolicy) { this.$message.error(`${item.itemName}规则国家和访问策略不能为空`); return false }
        }
      }
      return true
    },
    buildPayload() {
      return {
        ...this.form,
        checkMockUserIdList: this.joinCsv(this.splitCsv(this.form.checkMockUserIdList)),
        bypassMockUserIdList: this.joinCsv(this.splitCsv(this.form.bypassMockUserIdList)),
        items: this.form.items.map((item) => ({
          itemCode: item.itemCode,
          itemName: item.itemName,
          apiList: item.apiList,
          rules: item.rules.map((rule) => ({
            countryCode: rule.countryCode,
            regionList: rule.countryCode === 'OTHER' ? 'ALL' : this.joinCsv(rule.regionList && rule.regionList.length ? rule.regionList : ['ALL']),
            accessPolicy: rule.accessPolicy,
          })),
        })),
      }
    },
    validateMockUsers(value, callback) {
      const items = this.splitCsv(value)
      if (items.length > 5) { callback(new Error('模拟盘用户白名单最多填写5个')); return }
      if (items.some((item) => !/^\d+$/.test(item))) { callback(new Error('模拟盘用户ID只能填写数字')); return }
      callback()
    },
    splitCsv(value) {
      if (!value) return []
      return String(value).split(',').map((item) => item.trim()).filter(Boolean).filter((item, index, array) => array.indexOf(item) === index)
    },
    joinCsv(value) {
      return Array.isArray(value) ? value.map((item) => String(item).trim()).filter(Boolean).join(',') : ''
    },
    handleSwitch(row) {
      const next = !row.enabled
      this.$confirm(`确认${next ? '启用' : '禁用'}该配置？`, '提示', { type: 'warning' }).then(() => api.switchEnabled(row.id, next)).then((res) => {
        if (res && res.code === 0) { this.$message.success('操作成功'); this.loadList() }
      })
    },
    handleDelete(row) {
      this.$confirm('确认删除该配置？', '提示', { type: 'warning' }).then(() => api.remove(row.id)).then((res) => {
        if (res && res.code === 0) { this.$message.success('删除成功'); this.loadList() }
      })
    },
  },
}
</script>

<style scoped lang="less">
.ios-limit-actions { justify-content: space-between; }
.limit-section { margin-left: 0; }
.section-title { display: flex; align-items: center; justify-content: space-between; margin: 12px 0; font-weight: 600; }
.limit-item { border: 1px solid #ebeef5; padding: 12px; margin-bottom: 12px; }
.item-head { display: flex; align-items: center; gap: 12px; margin-bottom: 10px; }
.api-text { flex: 1; color: #606266; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.rule-actions { margin-top: 10px; }
.danger-text { color: #f56c6c; }
</style>
